export const hasPartnerIntentQuery = {
  tags: {
    $where: {
      type: 'Intent',
      name: 'Partner'
    },
    // $count: {
    //   operator: 'gte',
    //   value: 1
    // }
  }
};

export const hasEducatorIntentQuery = {
  tags: {
    $where: {
      type: 'Intent',
      name: 'Educator'
    },
    // $count: {
    //   operator: 'gte',
    //   value: 1
    // }
  }
};
